import React from 'react';
import { Badge, Button } from 'react-bootstrap';

const FieldMappingsSideNav = ({ 
  categories, 
  activeSection, 
  setActiveSection,
  mappingStats
}) => {
  // Calculate if all fields are mapped
  const allFieldsMapped = Object.values(mappingStats).every(
    stats => stats.mapped === stats.total && stats.total > 0
  );

  return (
    <div className="side-navigation">
      {/* Brand Section */}
      <div className="brand-section">
        <h5 className="mb-0">Field Mappings</h5>
      </div>
      
      {/* Navigation Items */}
      <div className="nav-items">
        {categories.map((category, index) => {
          const stats = mappingStats[category] || { mapped: 0, total: 0 };
          const isComplete = stats.mapped === stats.total && stats.total > 0;
          const isActive = activeSection === index;
          
          return (
            <div 
              key={category}
              className={`nav-item ${isActive ? 'active-option2' : ''} ${isComplete ? 'completed' : ''}`}
              onClick={() => setActiveSection(index)}
              style={{ position: isActive ? 'relative' : 'static' }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>{category}</span>
                <Badge pill bg={isComplete ? 'success' : 'primary'}>
                  {stats.mapped}/{stats.total}
                </Badge>
              </div>
            </div>
          );
        })}
      </div>
      
      
    </div>
  );
};

export default FieldMappingsSideNav;